module.exports = __webpack_public_path__ + "static/tags.4d79052a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/img/tags.jpg
// module id = 183
// module chunks = 129745722219136 183400410456155